/**
 * Shared world constants. Client and server MUST agree on every value here --
 * the client interpolates movement locally using the same numbers the server
 * uses to advance its authoritative simulation.
 */

/** Width of one floor tile in screen pixels. */
export const TILE_WIDTH = 64;
/** Height of one floor tile in screen pixels. Classic 2:1 isometric ratio. */
export const TILE_HEIGHT = 32;
/** Vertical screen offset applied per unit of tile height (z). */
export const TILE_DEPTH = 16;

/** Milliseconds an avatar spends walking from the centre of one tile to the next. */
export const STEP_DURATION_MS = 400;

/** Server simulation frequency. */
export const TICK_RATE_HZ = 10;
export const TICK_INTERVAL_MS = 1000 / TICK_RATE_HZ;

/**
 * How often the server pushes a full authoritative snapshot of the room so
 * clients can correct any accumulated interpolation drift.
 */
export const SNAPSHOT_INTERVAL_MS = 5000;

/** Largest height difference an avatar may step up or down in one move. */
export const MAX_STEP_HEIGHT = 1.5;

/** Hard ceiling on a single pathfinding request, to bound worst-case CPU. */
export const MAX_PATH_LENGTH = 128;

export const MAX_CHAT_LENGTH = 240;
export const MAX_DISPLAY_NAME_LENGTH = 24;
export const MIN_DISPLAY_NAME_LENGTH = 3;

/** Per-connection rate limits, enforced server side. */
export const RATE_LIMITS = {
  chatPerTenSeconds: 8,
  movesPerTenSeconds: 30,
  messagesPerTenSeconds: 60,
} as const;

/** Heartbeat: server pings, and drops a socket that has not ponged in time. */
export const HEARTBEAT_INTERVAL_MS = 15_000;
export const HEARTBEAT_TIMEOUT_MS = 35_000;

/** The eight isometric facing directions, clockwise from "north". */
export const DIRECTIONS = [0, 1, 2, 3, 4, 5, 6, 7] as const;
export type Direction = (typeof DIRECTIONS)[number];
